<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Umowy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTab">
  <mat-tab label="Dane">
    <app-contract-details-view *ngIf="!modify" [contract]="contract" [editBlock]="editBlock" (modifyClicked)="modify = true" (terminated)="loadContract()" ></app-contract-details-view>
    <app-contract-details-form *ngIf="modify" [contract]="contract" (closeModification)="modify = false; loadContract()"></app-contract-details-form>
  </mat-tab>
  <mat-tab label="TU (załączniki do umowy)" [disabled]="!INSURANCE_COMPANY_ANNEX_CONTRACT_TYPES.includes(contractObject?.type?.key)">
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="15px" class="add-button">
          <div>
            <button [disabled]="!(userPermissions | async).contract.create" mat-stroked-button color="primary"
                    (click)="addInsuranceCompany()"><mat-icon>add</mat-icon> Dodaj TU</button>
          </div>

          <div>
            <button
              mat-stroked-button [matMenuTriggerFor]="menu"
              aria-label="Menu" color="primary"
              [disabled]="!(userPermissions | async).contract.write || processingRequest"
              [class.spinner]="processingRequest"
            >
              Odznacz wszystkie
            </button>
            <mat-menu #menu="matMenu">
              <button
                [disabled]="!(userPermissions | async).contract.write || processingRequest"
                [class.spinner]="processingRequest"
                (click)="updateAllAnnexes('sent')"
                mat-menu-item
              >Wysłany</button>

              <button
                [disabled]="!(userPermissions | async).contract.write || processingRequest"
                [class.spinner]="processingRequest"
                (click)="updateAllAnnexes('signed')"
                mat-menu-item
              >Podpisany</button>

              <button
                [disabled]="!(userPermissions | async).contract.write || processingRequest"
                [class.spinner]="processingRequest"
                (click)="updateAllAnnexes('returned')"
                mat-menu-item
              >Zwrócony</button>
            </mat-menu>
          </div>
        </div>

        <div fxLayout="row">
          <app-all-contract-insurance-companies-list
            fxFlex="100"
            [disableFilters]="true" [disableBreadcrumb]="true" [contract]="contractId" [embeddedView]="true"
            [excludeColumns]="['party', 'status', 'assetsRegional', 'contract']" [reloadList]="reloadInsuranceCompanyList"
          ></app-all-contract-insurance-companies-list>
        </div>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-document-list [excludeColumns]="['deviceProtocolDate']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Rejestracje" [disabled]="!REGISTRATION_CONTRACT_TYPES.includes(contractObject?.type?.key)">
    <ng-template matTabContent>
<!--      <button [disabled]="!(userPermissions | async).registration.create" mat-stroked-button color="primary" class="add-button"-->
<!--              (click)="addRegistration()"><mat-icon>add</mat-icon> Dodaj rejestrację</button>-->

      <app-all-registrations-list
        [excludeColumns]="['ofwca_just', 'insuranceCompany_just','passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack', 'trainingRequirement', 'requirementMet']"
        [contractId]="contractObject.uuid" [disableFilters]="true" [disableBreadcrumb]="true" [reloadList]="registrationsChanged"
        [embeddedView]="true"
      >

      </app-all-registrations-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Przepięcia OFWCA" *ngIf="(userPermissions | async).registration.create && [
    CONTRACT_STATUS_DURING_TERMINATION,
    CONTRACT_STATUS_TO_TERMINATE,
    CONTRACT_STATUS_TERMINATED
  ].includes(contractObject?.status?.key) && ![
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_LEAD,
  CONTRACT_TYPE_LEASING,
  CONTRACT_TYPE_TERMINAL
  ].includes(contractObject?.type?.key)">
    <ng-template matTabContent>
      <app-ofwca-to-reassign-list [contract]="contract"></app-ofwca-to-reassign-list>
    </ng-template>
  </mat-tab>
<!--  <mat-tab label="Zgłoszenia" [disabled]="!REGISTRATION_CONTRACT_TYPES.includes(contractObject?.type?.key)">-->
<!--    <ng-template matTabContent>-->
<!--      <app-contract-ofwca-applications-list [contract]="contractObject"></app-contract-ofwca-applications-list>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [contract]="contract"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
